import { useEffect, useState } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { ClubEvent } from "@/lib/types";

export function useEvents(clubId: string | undefined) {
  const [events, setEvents] = useState<(ClubEvent & { id: string })[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) {
      setEvents([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, "clubs", clubId, "events"),
      orderBy("date", "asc")
    );

    const unsub = onSnapshot(q, (snap) => {
      const items = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      })) as (ClubEvent & { id: string })[];
      setEvents(items);
      setLoading(false);
    });

    return unsub;
  }, [clubId]);

  // Split into upcoming and past
  const today = new Date().toISOString().split("T")[0];
  const upcoming = events.filter((e) => e.date >= today);
  const past = events.filter((e) => e.date < today);

  return { events, upcoming, past, loading };
}
